import { win } from '@wix/cashier-common/dist/src/utils/win';
import s from '../styles/vars.scss';
import { type DeviceType } from '../types/DeviceType';

export const mobileQuery = `screen and (max-width: ${s.mobileBreakpoint})`;

export const getDeviceTypeObserver = () => win.matchMedia(mobileQuery);
export const getDeviceType = (): DeviceType => (getDeviceTypeObserver().matches ? 'mobile' : 'desktop');
